/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Access_Request_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to send access request." |
*
* @param {Project_Access_Request_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_request_error = /** @type {((inputs?: Project_Access_Request_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Request_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugriffsanfrage konnte nicht gesendet werden.")
	return /** @type {LocalizedString} */ ("Failed to send access request.")
});